export default __webpack_public_path__ + "static/media/card-info.0561e1e8.svg";